import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import MKTypography from "components/MKTypography";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";

SignVideo.propTypes = {
  source: PropTypes.string.isRequired, // Video source
  style: PropTypes.object, // Styling for the video
  onProcessVideo: PropTypes.func, // Function to process video and retrieve landmarks
  landmarks: PropTypes.array, // Landmarks data to display or handle
};

function SignVideo({ source, style, onProcessVideo, landmarks, ...rest }) {
  const videoRef = useRef(null);
  const [available, setAvailable] = useState(true);
  const [hover, setHover] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    if (videoRef && videoRef.current) {
      videoRef.current.addEventListener("play", () => {
        setIsPlaying(true);

        // Trigger video processing and pass the video element
        if (onProcessVideo) {
          onProcessVideo(videoRef.current);
        }
      });
      videoRef.current.addEventListener("pause", () => {
        setIsPlaying(false);
      });
    }
  }, [videoRef, onProcessVideo]);

  const play = () => {
    if (available) videoRef.current.play();
  };

  return (
    <>
      <div style={{ position: "relative", lineHeight: "1rem", aspectRatio: "16 / 9" }}>
        <video
          ref={videoRef}
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
          onError={() => setAvailable(false)}
          onLoadedMetadata={() => setAvailable(true)}
          style={{ width: "100%", ...style }}
          src={source}
          loop={true}
          controls={hover && isPlaying}
          {...rest}
        ></video>
        {!isPlaying && (
          <div
            style={{
              position: "absolute",
              left: 0,
              width: "100%",
              top: 0,
              height: "100%",
              display: "flex",
              alignContent: "center",
              justifyContent: "center",
              flexWrap: "wrap",
              cursor: available ? "pointer" : "default",
            }}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            onClick={play}
          >
            {available ? (
              <div
                style={{
                  zIndex: 100,
                  textAlign: "center",
                  backgroundColor: "#000000a0",
                  borderRadius: "50%",
                }}
              >
                <PlayArrowIcon fontSize="large" color="light" />
              </div>
            ) : (
              <MKTypography variant="body2" fontSize="small">
                Video no disponible
              </MKTypography>
            )}
          </div>
        )}
        {/* Optional: Display landmarks data */}
        {landmarks && (
          <MKTypography variant="body2" style={{ position: "absolute", bottom: "10px", left: "10px", color: "white" }}>
            {`Landmarks detected: ${landmarks.length}`}
          </MKTypography>
        )}
      </div>
    </>
  );
}

export default SignVideo;
